import { ArrowRight, Users } from 'lucide-react'
import React from 'react'
import { Link } from 'react-router-dom'
import { FaWhatsapp } from "react-icons/fa";
const InvestmentReadlines = () => {
    return (
        <>
        <section className="container mx-auto px-4 sm:px-6 py-8" >
            <div className="flex flex-col lg:flex-row items-center gap-12 lg:gap-16">

                {/* Left - Content */}
                <div className="flex-1 text-center lg:text-left">
                   
                    <h1 className="text-[20px] md:text-5xl lg:text-4xl font-bold text-gray-800 mb-3 leading-tight">
                    {' '}TACTOS Investment Readiness
                        <span className="text-[#fd3e3d]"> BOOTCAMP / COHORT</span>
                    </h1>

                     <div className="inline-flex items-center gap-2 px-4 py-2 rounded-full bg-[#fd3e3d]/10 text-[#fd3e3d] text-sm font-medium mb-4">
                        <Users className="w-4 h-4" />
                     
                        <span>Get Investor - Ready in Just 5 - 7 Days</span>
                    </div>


                    <p className="text-black/70 text-sm md:text-md mb-6 max-w-xl mx-auto lg:mx-0">
                        A 5 - 7 day fast-track program that transforms founders into
                        pitch-ready entrepreneurs. Designed for rapid learning,
                        product sharpening, and immediate investor exposure. Each
                        bootcamp ends with a live pitch to local funds and strategic
                        partners.
                    </p>

                    {/* CTA */}
                    <div className="flex justify-center lg:justify-start">
                        <Link
                            to="/instructions/investment"
                            className="group inline-flex items-center gap-3 bg-[#fd3e3d] hover:bg-[#e63635] text-white font-semibold py-3 px-8 rounded-xl transition-all duration-300 shadow-lg shadow-[#fd3e3d]/25 hover:shadow-[#fd3e3d]/40"
                        >
                            Apply Now
                            <ArrowRight className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                        </Link>
                    </div>
                </div>

                {/* Right - Image (hidden on mobile) */}
                <div className="flex-1 hidden lg:flex justify-center">
                    <img
                        src="/bootcampnew.webp"
                        alt="Investment Readiness"
                        className="w-full max-w-md object-contain rounded-2xl"
                    />
                </div>

            </div>
        </section>
  <section className="container mx-auto px-4 sm:px-6 py-10">
  <div className="relative p-[2px] rounded-2xl running-border">
    
    {/* INNER CARD */}
     <div
  className="relative rounded-2xl overflow-hidden"
  style={{  
    backgroundImage: "url('/whatsappnew.jpg')",
    backgroundSize: "cover",
    backgroundPosition: "50% 50%", // exact center
    backgroundRepeat: "no-repeat",
  }}>
      {/* Dark overlay */}
      {/* <div className="absolute inset-0 bg-black/70"></div> */}

      {/* Content */}
      <div className="relative z-10 flex flex-col md:flex-row items-center justify-between gap-6 px-6 md:px-10 py-8">
        
        <h2 className="text-white text-lg md:text-2xl font-bold text-center md:text-left max-w-xl">
          Let’s Talk Strategy, Growth & Execution
          <span className="block font-bold">
            Join with TACTOS on{" "}
            <span className="text-[#25D366]">WhatsApp</span>
          </span>
        </h2>

        <a
  href="https://chat.whatsapp.com/HTyaQwXSQWfB32EeIHq60L"
  target="_blank"
  rel="noopener noreferrer"
  className="relative p-[2px] rounded-xl running-border-btn"
>
  <span
    className="
      relative z-10
      inline-flex items-center gap-3
      bg-white text-[#25D366]
      font-semibold
      px-6 py-3 rounded-xl
      shadow-lg
      hover:bg-gray-100
      transition
    "
  >
    <FaWhatsapp className="text-2xl" />
    Chat on WhatsApp
  </span>
</a>

      </div>
    </div>
  </div>
</section>



        </>
    )
}

export default InvestmentReadlines
